function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { createContainer } from './base';
import { CSS_VARS, DEFAULT_ITEMS } from './constants';
import { createFragment, find } from './helpers/dom';
import { contains, getUniqueId } from './helpers/mix';

/**
 * @class Html
 */
export var Html = /*#__PURE__*/function () {
  /**
   * @constructor
   * @param {Function} base Base class.
   */
  function Html(base) {
    _classCallCheck(this, Html);
    this.Base = base;
    this.container = this.Base.container;
    return this;
  }
  _createClass(Html, [{
    key: "createMenu",
    value: function createMenu() {
      var items = [];
      if ('items' in this.Base.options) {
        items = this.Base.options.defaultItems ? this.Base.options.items.concat(DEFAULT_ITEMS) : this.Base.options.items;
      } else if (this.Base.options.defaultItems) {
        items = DEFAULT_ITEMS;
      }
      // no item
      if (items.length === 0) return false;
      // create entries
      items.forEach(this.addMenuEntry, this);
    }
  }, {
    key: "addMenuEntry",
    value: function addMenuEntry(item) {
      var _this = this;
      if (item.items && Array.isArray(item.items)) {
        // submenu - only a second level
        item.classname = item.classname || '';
        if (!contains(CSS_VARS.submenu, item.classname)) {
          item.classname = item.classname.length ? " ".concat(CSS_VARS.submenu) : CSS_VARS.submenu;
        }
        var li = this.generateHtmlAndPublish(this.container, item);
        var sub = createContainer(false, this.Base.options.width);
        sub.style.left = this.Base.Internal.submenu.lastLeft || this.Base.Internal.submenu.left;
        li.appendChild(sub);
        item.items.forEach(function (each) {
          _this.generateHtmlAndPublish(sub, each, true);
        });
      } else {
        this.generateHtmlAndPublish(this.container, item);
      }
    }
  }, {
    key: "generateHtmlAndPublish",
    value: function generateHtmlAndPublish(parent, item, submenu) {
      var index = getUniqueId();
      var html,
        frag,
        element,
        separator = false;

      // separator
      if (typeof item === 'string' && item.trim() === '-') {
        html = "<li id=\"".concat(index, "\" class=\"").concat(CSS_VARS.separator, "\"><hr></li>");
        frag = createFragment(html);
        // http://stackoverflow.com/a/13347298/4640499
        element = [].slice.call(frag.childNodes, 0)[0];
        parent.firstChild.appendChild(frag);
        // to exclude from lineHeight calculation
        separator = true;
      } else {
        item.classname = item.classname || '';
        html = "<span>".concat(item.text, "</span>");
        frag = createFragment(html);
        element = document.createElement('li');
        if (item.icon) {
          if (item.classname === '') {
            item.classname = CSS_VARS.icon;
          } else if (item.classname.indexOf(CSS_VARS.icon) === -1) {
            item.classname += " ".concat(CSS_VARS.icon);
          }
          element.setAttribute('style', "background-image:url(".concat(item.icon, ")"));
        }
        element.id = index;
        element.className = item.classname;
        element.appendChild(frag);
        parent.firstChild.appendChild(element);
      }
      this.Base.Internal.items[index] = {
        id: index,
        submenu: submenu || 0,
        separator: separator,
        callback: item.callback,
        data: item.data || null
      };
      this.Base.Internal.setItemListener(element, index);
      return element;
    }
  }, {
    key: "removeMenuEntry",
    value: function removeMenuEntry(index) {
      var element = find("#".concat(index), this.container.firstChild);
      element && this.container.firstChild.removeChild(element);
      delete this.Base.Internal.items[index];
    }
  }, {
    key: "cloneAndGetLineHeight",
    value: function cloneAndGetLineHeight() {
      // for some reason I have to calculate with 2 items
      var cloned = this.container.cloneNode();
      var frag = createFragment('<span>Foo</span>');
      var frag2 = createFragment('<span>Foo</span>');
      var element = document.createElement('li');
      var element2 = document.createElement('li');
      element.appendChild(frag);
      element2.appendChild(frag2);
      cloned.appendChild(element);
      cloned.appendChild(element2);
      this.container.parentNode.appendChild(cloned);
      var height = cloned.offsetHeight / 2;
      this.container.parentNode.removeChild(cloned);
      return height;
    }
  }]);
  return Html;
}();